import TableData from "./TableData";

export default TableData;
export { default as TableDataDesktop } from "./TableDataDesktop/TableDataDesktop";
